// Copyright © 2021 Move Closer
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export var ShareType;
(function (ShareType) {
    ShareType["CopyLink"] = "copy-link";
    ShareType["Email"] = "email";
    ShareType["Facebook"] = "facebook";
    ShareType["Instagram"] = "instagram";
    ShareType["Link"] = "link";
    ShareType["LinkedIn"] = "linkedin";
    ShareType["Twitter"] = "twitter";
})(ShareType || (ShareType = {}));
